import { vendorTranslations } from "./vendor-pt-br";

export const vendors_FR_FR: vendorTranslations = {
	title: "Vendeurs",
	searchNamePlaceholder: "Rechercher par nom/login de vendeur",
	header: {
		create: "Créer un vendeur",
		batchPermissions: "Permissions par lots",
	},
	list: {
		vendors: "Vendeurs",
		rent: "Location",
		revenuePercentageFee: "Pourcentage de revenus",
		tipPercentageFee: "Pourcentage de pourboire",
		places: "Lieux",
		fiscalProfile: "Profil fiscal",
		login: "Identifiant",
		paymentDaysOffset: "Jours de paiement",
		productsSpecialFee: "Frais spéciaux",
		product: "produit",
		products: "produits",
		actions: {
			editVendor: "Modifier le vendeur",
			deleteVendor: "Supprimer le vendeur",
		},
		place: "Lieu",
		bars: "Bars",
	},
	modal: {
		close: "Fermer",
		prevStep: "Étape précédente",
		nextStep: "Étape suivante",
		steps: {
			dataCollection: "Données du vendeur",
			barSelection: "Données des lieux et bars",
			feesCalculation: "Frais et profil fiscal",
			guidance: "Guide",
		},
		delete: {
			title: "Supprimer le vendeur",
			description: "Êtes-vous sûr de vouloir supprimer ce vendeur ?",
			buttonConfirm: "Confirmer",
		},
		mode: {
			create: "Créer un nouveau vendeur",
			update: "Modifier le vendeur",
			updateDataCollection: "Modifier les données du vendeur",
			updateLinkingBarsAndLocations: "Modifier les lieux et bars",
			updateFeesTaxProfile: "Modifier les frais et le profil fiscal",
		},
		submit: {
			create: "Créer le vendeur",
			update: "Enregistrer",
		},
		form: {
			required: "Champ requis",
			nonnegative: "La valeur doit être supérieure ou égale à zéro",
			name: {
				label: "Nom",
				validation: "Le nom ne peut pas être vide",
				placeholder: "Entrez le nom du vendeur",
				nonempty: "Le nom ne peut pas être vide",
			},
			login: {
				label: "Identifiant",
				validation: "L'identifiant ne peut pas être vide",
				placeholder: "Entrez l'identifiant du vendeur",
				nonempty: "L'identifiant ne peut pas être vide",
				emailRegexValidation: "L'identifiant ne doit pas être un email",
				charactersRegexValidation:
					"L'identifiant ne peut pas contenir de majuscules ni de caractères spéciaux",
			},
			password: {
				label: "Mot de passe",
				validation: "Le mot de passe ne peut pas être vide",
				placeholder: "Entrez le mot de passe du vendeur",
				required: "Mot de passe requis",
				nonempty: "Le mot de passe ne peut pas être vide",
			},
			places: {
				label: "Lieux",
				validation: "Sélectionnez au moins un lieu",
				placeholder: "Sélectionnez les lieux où le vendeur sera actif",
				selectAll: "Tout sélectionner",
			},
			bars: {
				label: "Bars",
				validation: "Sélectionnez au moins un bar",
				placeholder: "Sélectionnez les bars du vendeur",
				noBars: "Aucun bar sélectionné",
			},
			dailyRentalFeeValue: {
				label: "Frais fixes par événement",
			},
			revenuePercentageFee: {
				label: "Pourcentage de revenus",
			},
			tipPercentageFee: {
				label: "Pourcentage de pourboire",
			},
			paymentDaysOffset: {
				label: "Jours pour effectuer le paiement (J+)",
				maxValidation: "Doit être entre 0 et {{count}}",
			},
			anticipationFee: {
				label: "Frais d'anticipation",
			},
			fiscalProfileId: {
				label: "Profil fiscal",
				placeholder: "Sélectionnez le profil fiscal",
			},
			isFinancialVendor: {
				label: "Clôtures financières",
				description: "Générer des clôtures financières pour ce vendeur",
			},
			paymentMethodFees: {
				credit: "Frais de paiement par carte de crédit",
				debit: "Frais de paiement par carte de débit",
				pix: "Frais de paiement par pix",
			},
			productFees: {
				productFee: "Frais spéciaux par produit",
				productFeePlaceholder: "Rechercher un produit",
				percent: "Pourcentage",
				button: "Ajouter un autre produit",
			},
			fullName: {
				label: "Nom complet",
				validation: "Le nom complet ne peut pas être vide",
				nonempty: "Le nom complet ne peut pas être vide",
				placeholder: "Entrez le nom complet du vendeur",
				required: "Nom complet requis",
			},
			postalCode: {
				label: "Code postal",
				required: "Code postal requis",
				invalid: "Code postal invalide",
				placeholder: "Entrez le code postal du vendeur",
			},
			streetName: {
				label: "Nom de la rue",
				required: "Nom de la rue requis",
				nonempty: "Le nom de la rue ne peut pas être vide",
				placeholder: "Entrez le nom de la rue du vendeur",
			},
			addressNumber: {
				label: "Numéro",
				required: "Numéro requis",
				nonempty: "Le numéro ne peut pas être vide",
				placeholder: "Entrez le numéro de rue du vendeur",
			},
			city: {
				label: "Ville",
				required: "Ville requise",
				nonempty: "La ville ne peut pas être vide",
				placeholder: "Entrez la ville du vendeur",
			},
			state: {
				label: "État",
				required: "État requis",
				nonempty: "L'état ne peut pas être vide",
				placeholder: "Entrez l'état du vendeur",
			},
			province: {
				label: "Bairro",
				placeholder: "Entrez le bairro du vendeur",
				required: "Bairro requis",
			},
			complement: {
				label: "Complément",
				placeholder: "Entrez le complément du vendeur",
				required: "Complément requis",
			},
			phone: {
				label: "Téléphone",
				required: "Téléphone requis",
				nonempty: "Le téléphone ne peut pas être vide",
				invalid: "Téléphone invalide",
				placeholder: "Entrez le téléphone du vendeur",
			},
			email: {
				label: "E-mail",
				required: "E-mail requis",
				nonempty: "L'e-mail ne peut pas être vide",
				invalid: "E-mail invalide",
				placeholder: "Entrez l'e-mail du vendeur",
			},
			documentType: {
				label: "Type de document",
				placeholder: "Sélectionnez le type de document",
				required: "Type de document requis",
			},
			documentNumber: {
				label: "Numéro de document",
				placeholder: "Entrez le numéro de document",
				required: "Numéro de document requis",
			},
			cpf: {
				label: "CPF",
				placeholder: "Entrez le CPF du vendeur",
			},
			cnpj: {
				label: "CNPJ",
				placeholder: "Entrez le CNPJ du vendeur",
			},
			international: {
				label: "Document international",
				placeholder: "Entrez le document international",
			},
			floorComplement: "Minimum garanti par événement",
			featureAlert:
				"Le montant restant ne sera distribué que si le bar principal de la caisse qui a effectué le prélèvement appartient au vendeur. Il est facturé sur la taxe de vente du montant restant du vendeur.",
		},
		guidance: {
			vendorData: {
				title: "Modifier les données du vendeur",
				description: "Nom, identifiant et mot de passe",
			},
			linkingBarsAndLocations: {
				title: "Modifier les lieux et bars",
				description: "Sélectionnez les lieux du vendeur et ses bars",
			},
			feesTaxProfile: {
				title: "Modifier les tarifs et le profil fiscal",
				description:
					"Tarifs journaliers, pourcentage sur les revenus, pourcentage sur le service, jour de paiement et profil fiscal",
			},
		},
		productModal: {
			title: "Produits et frais spéciaux",
			product: "Produit",
			fee: "Frais",
			closeConfirmTitle: "Annuler les modifications des frais spéciaux",
			closeConfirmSubtitle:
				"Vous avez effectué des modifications qui ne seront enregistrées que si vous cliquez sur 'enregistrer les modifications'. Souhaitez-vous annuler les modifications effectuées ou revenir à l'édition des tarifs ?",
			closeConfirmCancelActionText: "Revenir à l'édition",
			closeConfirmConfirmActionText: "Annuler les modifications",
			save: "Enregistrer les modifications",
			deleteConfirmTitle: "Supprimer les frais spéciaux",
			deleteConfirmSubtitle: "Voulez-vous supprimer les frais spéciaux de '{{value}}' ?",
			deleteConfirmBoldSubtitle: "Cette action ne peut pas être annulée",
		},
	},
	modalPermissions: {
		single: {
			edit: "Modifier {{vendorName}}",
			withdraw: "Bloquer le retrait",
			anticipation: "Autoriser la demande d'anticipation",
			financialVendor: "Générer les clôtures financières",
			remove: "Supprimer le vendeur",
		},
		multiple: {
			title: "{{count}} vendeurs sélectionnés",
			blockWithdraw: {
				title: "Bloquer le retrait",
				subtitle: "Bloquer le retrait de {{count}} vendeurs",
				description:
					"Cette action bloquera le retrait des vendeurs ci-dessous dans tous les lieux.",
				confirm: "Confirmer le blocage du retrait",
			},
			canAnticipate: {
				title: "Autoriser l'anticipation",
				subtitle: "Bloquer l'anticipation de {{count}} vendeurs",
				description:
					"Cette action bloquera l'anticipation des vendeurs ci-dessous dans tous les lieux.",
				confirm: "Confirmer le blocage de l'anticipation",
			},
			cancel: "Fermer",
			applySelection: "Appliquer la sélection",
		},
		thisAction: "Cette action",
		vendorsBelow: "des vendeurs ci-dessous dans tous les lieux",
		featureTitleBothAllowed: "Autoriser le retrait et l'anticipation",
		featureTitleBothBlocked: "Bloquer le retrait et l'anticipation",
		featureTitleMixed: "{{withdraw}} retrait et {{anticipation}} anticipation",
		block: "Bloquer",
		allow: "Autoriser",
		vendorsCount_one: "de 01 vendeur",
		vendorsCount_other: "de {{count}} vendeurs",
	},
};
